import { IGetAllAtividadeObraUseCase } from "../../../presentation/useCases/read/get_all_atividade_obra_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { AtividadeObra } from "../../models/atividade_obra";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllAtividadeObraUseCase
 */

export class GetAllAtividadeObraUseCase extends BasePaginatedUseCase<AtividadeObra> implements IGetAllAtividadeObraUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllAtividadeObra(
    idObra: number | undefined,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObra === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository
      .getAllAtividadeObra(
        idObra,
        page,
        rowsPerPage,
      );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
